import React from 'react';
import { PERMISSION_DENIED, geolocationSupported, watchGeolocationPermission } from './geolocationPermission';
const TIMEOUT_MS = 8000;
const MAXIMUM_AGE_MS = 300000;
const LOCATING = { status: 'locating', point: null, denied: false };
const FALLBACK = { status: 'fallback', point: null, denied: false };
const DENIED = { status: 'fallback', point: null, denied: true };
// One rough position, read without asking only if the visitor already allowed it before; otherwise
// the fallback stands until request() is called from a tap.
export const useGeolocation = ({ fallback }) => {
    var _a;
    const [state, setState] = React.useState(() => geolocationSupported() ? LOCATING : FALLBACK);
    const mounted = React.useRef(true);
    React.useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);
    const request = React.useCallback(() => {
        const settle = (next) => {
            if (mounted.current)
                setState(next);
        };
        if (geolocationSupported()) {
            setState(current => (Object.assign(Object.assign({}, current), { status: 'locating' })));
            navigator.geolocation.getCurrentPosition(({ coords }) => settle({ status: 'located', point: [coords.longitude, coords.latitude], denied: false }), error => settle(error.code === PERMISSION_DENIED ? DENIED : FALLBACK), { timeout: TIMEOUT_MS, maximumAge: MAXIMUM_AGE_MS, enableHighAccuracy: false });
        }
        else {
            setState(FALLBACK);
        }
    }, []);
    React.useEffect(() => {
        if (!geolocationSupported())
            return undefined;
        return watchGeolocationPermission(permission => {
            if (permission === 'granted')
                request();
            else
                setState(permission === 'denied' ? DENIED : FALLBACK);
        });
    }, [request]);
    return {
        point: (_a = state.point) !== null && _a !== void 0 ? _a : (state.status === 'locating' ? null : fallback),
        status: state.status,
        canRequest: state.status === 'fallback' && !state.denied && geolocationSupported(),
        request,
    };
};
export default useGeolocation;
